import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const AssignmentsLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    view: LazyLoadedStates,
    bulkAssign: LazyLoadedStates
}>({
    base: {
        name: 'authenticated.assignments',
        url: '/assignments',
    },
    view: {
        name: 'authenticated.assignments.view',
        url: '/view?page&userType&bid&searchBy&isSupervisorOnly&limit',
        params: {
            isSupervisorOnly: {
                raw: true,
                type: 'bool'
            }
        }
    },
    bulkAssign: {
        name: 'authenticated.assignments.bulkAssign',
        url: '/bulkAssign'
    }
},
    () => import('src/app/assignments/pages/assignments.module').then(mod => mod.AssignmentsModule)
);
